export const JCP_NET_FACTOR = 0.825;

interface ProceedForTotal {
  corporateActionType: string;
  paymentDate: Date | string | null;
  total: number;
}

export function calculateProceedsTotals(
  proceeds: ProceedForTotal[]
): Record<string, number> {
  return proceeds.reduce<Record<string, number>>((totals, proceed) => {
    const paymentDate = String(proceed.paymentDate);
    const value =
      proceed.corporateActionType === 'JUROS SOBRE CAPITAL PRÓPRIO'
        ? Number(proceed.total) * JCP_NET_FACTOR
        : Number(proceed.total);

    totals[paymentDate] = (totals[paymentDate] ?? 0) + value;
    return totals;
  }, {});
}
